import React from "react"
import { Document, Page, Image } from "@react-pdf/renderer"
import uaLogo from "../../../assets/images/rsp-logo.png"

const A4_RATIO = 841.89 / 595.28

const makePageSlice = (canvas, pageHeight, srcY, srcH) => {
  const slice = document.createElement("canvas")
  slice.width = canvas.width
  slice.height = pageHeight
  const ctx = slice.getContext("2d")
  ctx.fillStyle = "#ffffff"
  ctx.fillRect(0, 0, slice.width, slice.height)
  ctx.drawImage(canvas, 0, srcY, canvas.width, srcH, 0, 0, canvas.width, srcH)
  return slice.toDataURL("image/png")
}

export const sliceCanvasIntoPages = (canvas) => {
  // Use exact A4 dimensions with Math.floor so slices are never taller than the
  // page — rounding up caused a ~0.35pt overflow that made react-pdf insert a
  // blank overflow page after every content page.
  const pageHeight = Math.floor(canvas.width * A4_RATIO)
  const pages = []
  for (let y = 0; y < canvas.height; y += pageHeight) {
    const sliceH = Math.min(pageHeight, canvas.height - y)
    pages.push(makePageSlice(canvas, pageHeight, y, sliceH))
  }
  return pages
}

// Slices canvas at card boundaries (using live DOM positions) so page breaks
// never cut through a card. Falls back to a natural cut only when a single
// card is taller than a full page.
export const sliceCanvasAtCards = (canvas, el, cardSelector) => {
  const pageHeight = Math.floor(canvas.width * A4_RATIO)
  const elRect = el.getBoundingClientRect()
  const scale = canvas.width / el.offsetWidth

  const cardBounds = Array.from(el.querySelectorAll(cardSelector)).map((card) => {
    const r = card.getBoundingClientRect()
    return {
      top: (r.top - elRect.top) * scale,
      bottom: (r.bottom - elRect.top) * scale,
    }
  })

  const pages = []
  let pageStart = 0

  while (pageStart < canvas.height) {
    const naturalEnd = pageStart + pageHeight

    if (naturalEnd >= canvas.height) {
      pages.push(makePageSlice(canvas, pageHeight, pageStart, canvas.height - pageStart))
      break
    }

    // Find a card that straddles the natural cut point
    const straddle = cardBounds.find((b) => b.top < naturalEnd && b.bottom > naturalEnd)

    if (straddle && straddle.top > pageStart) {
      // Cut just before the straddling card so it starts fresh on the next page
      const cutH = Math.round(straddle.top - pageStart)
      pages.push(makePageSlice(canvas, pageHeight, pageStart, cutH))
      pageStart = Math.round(straddle.top)
    } else {
      // Natural cut falls between cards (or card is bigger than a full page)
      pages.push(makePageSlice(canvas, pageHeight, pageStart, pageHeight))
      pageStart = naturalEnd
    }
  }

  return pages
}

const logoStyle = {
  position: "absolute", top: 12, left: 16, width: 115, height: 64,
}

const pageStyle = { padding: 0 }

const PlanImplicationsPDF = ({ summaryPages, suggestionPages }) => (
  <Document>
    {summaryPages.map((src, i) => (
      <Page key={`s-${i}`} size="A4" style={pageStyle}>
        <Image src={src} />
        {i === 0 && <Image src={uaLogo} style={logoStyle} />}
      </Page>
    ))}
    {suggestionPages.map((src, i) => (
      <Page key={`r-${i}`} size="A4" style={pageStyle}>
        <Image src={src} />
      </Page>
    ))}
  </Document>
)

export default PlanImplicationsPDF
